import React, { useState } from "react";
import { connect } from "react-redux";


// CSS STYLES
import styles from "../../styles/Components/Shared/ListPageFilterDropdown.module.css";
// ICONS    
import { SlArrowDown } from "react-icons/sl";

const ListPageFilterDropdown = ({
    // PARENT PROPS
    isClearFilterBtn,
    handleClearFilters,
    title, 
    options, 
    changeFilter, 
    selectedOption, 
    isDisabled,
    greenOnChange,
    addedStyles,
    valueIsBoolean
}) => {
    const [hidden, setHidden] = useState(false)

    if (!isClearFilterBtn && !options ) {
        return null
    }

    const selectedName = (selectedOption || valueIsBoolean && selectedOption === false) ? options.find(e => e.value === selectedOption) : null

    const handleChangeFilter = (value) => {
        changeFilter(value)
        setHidden(true)
        setTimeout(() => {
            setHidden(false)
        }, 1)
    }
    
    return !isClearFilterBtn ? (
        <div 
            className={isDisabled ? styles.dropdown_container : styles.dropdown_container_enabled}
        >
            <div className={`${styles.dropdown_content} ${hidden ? styles.dropdown_content_hidden : ''}`} >
                {options.map((option, i) => (
                    <p key={`option-${i}`} onClick={() => handleChangeFilter(option.value)}>{option.name}</p>
                )) }
            </div>
            <div 
                className={styles.dropdown_button} 
                style={{
                    ...greenOnChange ? {backgroundColor: 'var(--primary-green)', borderColor: 'var(--primary-green)'} : {},
                    ...addedStyles
                }}
            >
                <p>{selectedName ? selectedName.name : title}</p>
                <SlArrowDown size={20} color={'white'}/>
            </div>
        </div>
    ) : (
        <div className={styles.clear_filter_button} onClick={() => handleClearFilters()}>
            <p>Clear Filters</p>
        </div>
    )


};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {
})(ListPageFilterDropdown);



